exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-contaner,.layout-contaner>.ivu-layout,.menu,body,html{height:100%}.layout-contaner>.ivu-layout .ivu-layout-has-sider{height:calc(100% - 64px)}.contaner-title{font-size:18px;margin-bottom:10px}.contaner-title>span:first-of-type{color:#00aae3}.header-title{width:100%;background-color:#01aae3;color:#fff;height:64px;line-height:64px;padding-left:40px;-webkit-box-sizing:border-box;box-sizing:border-box;border-bottom:5px solid #0197ca}.header-title img{height:30px;margin-top:15px;float:left}.header-title span{font-size:14px;margin-left:20px;font-weight:400;float:left}.header-title p{float:right;margin-right:50px;font-size:15px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a78bf178","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/view/comment.vue
// module id = f2iE
// module chunks = 1